import { Dialog, DialogContent, DialogContentText, DialogActions, Button, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const ErrorToString = (err: Error | unknown | null) => {
    if (!err) {
        return "";
    }

    if (typeof err === "object" && "message" in err) {
        return (err as { message: string }).message;
    }

    if (Array.isArray(err) && err.length > 1) {
        return <>
            <span>Please correct the following errors:</span>
            <ul>
                {err.map((e, i) => <li key={i}>{ErrorToString(e)}</li>)}
            </ul>
        </>
    }

    return String(err);
}

interface ErrorDialogProps {
    err: Error | unknown | null;
    title?: string;
    info?: string | null;
    onClose?: () => void;
}

const ErrorDialog = (props: ErrorDialogProps) => {
    const [show, setShow] = useState<boolean>(false);
    const { t } = useTranslation();

    useEffect(() => {
        setShow(props.err != null);
    }, [props.err]);

    return <Dialog
        open={show}
        keepMounted
        onClose={() => setShow(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
    >
        {props.title && <DialogTitle>
            {props.title}
        </DialogTitle>}
        {/* MUI5 has no padding top on the first content child if there is no title */}
        <DialogContent style={{ paddingTop: props.title ? "0" : "20px" }}>
            <DialogContentText id="alert-dialog-slide-description">{ErrorToString(props.err)}</DialogContentText>
        </DialogContent>
        {props.info && <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">{props.info}</DialogContentText>
        </DialogContent>}
        <DialogActions>

            <Button onClick={() => {
                setShow(false);
                if (props.onClose) {
                    props.onClose();
                }
            }} color="inherit">{t("general.ok")}</Button>
        </DialogActions>
    </Dialog>
}

export default ErrorDialog;
